import cx from 'classnames';
import PropType from 'prop-types';

import createFieldClassNameByParticipantOrder from '@app/libs/participantFields/createFieldClassNameByParticipantOrder';

import './CheckboxIcon.scss';

const propTypes = {
  order: PropType.number,
};

const defaultProps = {
  order: 1,
};

function CheckboxIcon({ order }) {
  const checkboxIconClassByOrder = createFieldClassNameByParticipantOrder('CheckboxIcon', order);
  const className = cx('CheckboxIcon', checkboxIconClassByOrder);

  return (
    <svg className={className} height="18px" viewBox="0 0 18 18" width="18px">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g stroke="#FFAE00" transform="translate(-47.000000, -292.000000)">
          <g transform="translate(47.000000, 292.000000)">
            <polyline
              points="4.84960938 8.56082154 7.9973063 11.7085185 13.6901998 6.015625"
              strokeWidth="1.4"
            />
            <rect
              height="15.0795898"
              strokeWidth="2"
              width="15.0795898"
              x="1.47460938"
              y="1.41040039"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

CheckboxIcon.propTypes = propTypes;
CheckboxIcon.defaultProps = defaultProps;

export default CheckboxIcon;
